import React, {
  PropsWithChildren,
  ReactElement,
  ElementType,
  ForwardedRef,
} from 'react';
import { cn } from '@/utils';

type BaseProps = {
  className?: string;
  as?: ElementType;
};

type ResolvedProps<E extends ElementType> = BaseProps &
  PropsWithChildren<React.ComponentPropsWithRef<E>>;

const HoverableButton = React.forwardRef(
  <E extends ElementType = 'span'>(
    { children, className, as: Component = 'span', ...rest }: ResolvedProps<E>,
    ref: ForwardedRef<E>,
  ): ReactElement => {
    return (
      <Component
        ref={ref}
        className={cn(
          'inline-flex cursor-pointer rounded-lg p-2 hover:dark:bg-brand-dark-50 hover:dark:text-brand-light-100',
          className,
        )}
        {...rest}
      >
        {children}
      </Component>
    );
  },
);

export default HoverableButton;
